import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

// Actions
import * as AccountLeadDataActions from './accountLeadData.actions';

// Models
import { AccountType } from '../../../../accounts-v2/models/fields/accountType.model';
import { AnnualRevenue } from '../../model/annualRevenue.model';
import { Currency } from '../../model/currency.model';
import { EmployeeCount } from "../../model/employeeCount.model";
import { Industry } from "../../model/industry.model";
import { Ownership } from "../../model/ownership.model";
import { Rating } from "../../model/rating.model";
import { Timezone } from "../../model/timezone.model";

// Services
import { AccountsHttpService } from 'src/app/modules/shared/services/accounts.http.service';
import { CoreHttpService } from '../../services/core.http.service';

@Injectable()
export class AccountLeadDataEffects {
    constructor(
        private action$: Actions, 
        private accountsHttpService: AccountsHttpService,
        private coreHttpService: CoreHttpService) { }

    GetAccountTypes$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(AccountLeadDataActions.beginGetAccountTypes),
            mergeMap(() =>
                this.accountsHttpService.getAllAccountTypes().pipe(
                    map((accountTypes: AccountType[]) => {
                        return AccountLeadDataActions.successGetAccountTypes({ payload: accountTypes });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetAnnualRevenues$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(AccountLeadDataActions.beginGetAnnualRevenues),
            mergeMap(() =>
                this.coreHttpService.getAllAnnualRevenues().pipe(
                    map((annualRevenues: AnnualRevenue[]) => {
                        return AccountLeadDataActions.successGetAnnualRevenues({ payload: annualRevenues });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetCurrencies$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(AccountLeadDataActions.beginGetCurrencies),
            mergeMap(() =>
                this.coreHttpService.getAllCurrencies().pipe(
                    map((currencies: Currency[]) => {
                        return AccountLeadDataActions.successGetCurrencies({ payload: currencies });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetEmployeeCounts$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(AccountLeadDataActions.beginGetEmployeeCounts),
            mergeMap(() =>
                this.coreHttpService.getAllEmployeesCounts().pipe(
                    map((employeeCounts: EmployeeCount[]) => {
                        return AccountLeadDataActions.successGetEmployeeCounts({ payload: employeeCounts });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetIndustries$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(AccountLeadDataActions.beginGetIndustries),
            mergeMap(() =>
                this.coreHttpService.getAllIndustries().pipe(
                    map((industries: Industry[]) => {
                        return AccountLeadDataActions.successGetIndustries({ payload: industries });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetOwnerships$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(AccountLeadDataActions.beginGetOwnerships),
            mergeMap(() =>
                this.coreHttpService.getAllOwnerships().pipe(
                    map((ownerships: Ownership[]) => {
                        return AccountLeadDataActions.successGetOwnerships({ payload: ownerships });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetRatings$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(AccountLeadDataActions.beginGetRatings),
            mergeMap(() =>
                this.coreHttpService.getAllRatings().pipe(
                    map((ratings: Rating[]) => {
                        return AccountLeadDataActions.successGetRatings({ payload: ratings });
                    }),
                    catchError(() => [])
                )
            )
        )
    );

    GetTimezones$: Observable<Action> = createEffect(() =>
        this.action$.pipe(
            ofType(AccountLeadDataActions.beginGetTimezones),
            mergeMap(() =>
                this.coreHttpService.getAllTimezones().pipe(
                    map((timezones: Timezone[]) => {
                        return AccountLeadDataActions.successGetTimezones({ payload: timezones });
                    }),
                    catchError(() => [])
                )
            )
        )
    );
}